<template>
  <div class="add_address">
    <van-address-edit
      :address-info="formData"
      :area-list="areaData"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSubmit"
      :tel-validator="checkTel"
    ></van-address-edit>
  </div>
</template>
<script>
import areaData from "@/utils/area";
import http from "@/utils/axios";
export default {
  data() {
    return {
      areaData: [],
      showPicker: false,
      formData: {},
      showDelete: false,
      areaList: [],
    }; 
  },
  methods: {
    async getObjVal(value, type) {
      for (let i in this.areaData[type]) {
        if (this.areaData[type][i] == value) {
          return i;
        }
      }
    },
    async onSubmit(item) {
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (!reg.test(item.tel)) {
        this.$toast('请输入正确的手机号');
        return
      }
      this.formData = item;
      //console.log(item);
      let p = await this.getObjVal(item.province, "province_list");
      let c = await this.getObjVal(item.city, "city_list");
      let areaName = `${item.province} ${item.city} ${item.county}`;
      //console.log(item.areaCode);
      if (this.$route.query.id) {
        http({
          url: "order/app/branch/address/update",
          method: "post",
          parmes: {
            "address": item.addressDetail,
            "areaId": item.areaCode,
            "areaName": areaName,
            "branchId": this.$route.query.branchId,
            "cityId": c,
            "cityName": item.city,
            "id": this.$route.query.id,
            "provinceId": p,
            "provinceName": item.province,
            "userMobile": item.tel,
            "userName": item.name
          }
        }).then(rps => {
          if (rps.code === 200) {
            this.$notify({ type: "success", message: "修改成功" });
            this.$router.back();
          }
        });
      } else {
        http({
          url: "order/app/branch/address/add",
          method: "post",
          parmes: {
            "address": item.addressDetail,
            "afterId": this.$route.query.afterId || '',
            "areaId": item.areaCode,
            "areaName": areaName,
            "branchId": this.$route.query.branchId,
            "cityId": c,
            "cityName": item.city,
            "provinceId": p,
            "provinceName": item.province,
            "userMobile": item.tel,
            "userName": item.name
          }
        }).then(rps => {
          if (rps.code === 200) {
            this.$notify({ type: "success", message: rps.message || "成功!" });
            this.$router.back();
          } else {
            //
          }
        });
      }
    },
    getmyAddress(id) {
      http({
        url: "order/app/branch/address/detail/" + id,
        method: "get"
      }).then(rps => {
        if (rps.code === 200) {
          let arr = rps.data.areaName.split(" ");
          // console.log(arr);
          this.formData = {
            id: rps.data.id,
            name: rps.data.userName,
            tel: rps.data.userMobile,
            addressDetail: rps.data.address,
            areaCode: rps.data.areaId + "",
            province: arr[0],
            city: arr[1],
            county: arr[2],
          };
        }
      });
    },
    checkTel(val){
      let reg = /^1\d{10}$/
      if (!reg.test(val)) {
        return false
      }else{
        return true;
      }
    }
  },
  created() {
    this.$loading.hide();
    this.areaData = areaData;
    if (this.$route.query.id) {
      this.getmyAddress(this.$route.query.id);
    }
  },
};
</script>
<style lang="less" scoped>
.add_address {
  /deep/ .van-button--danger {
    color: var(--epTextColor);
    background: var(--epButtonColor);
    border: 1px solid var(--epButtonColor);
  }
}
.popup_address {
  .header {
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    padding: 10px 0;
  }
  .address_info {
    height: 400px;
    overflow-y: scroll;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .areaBox {
      width: 100%;
      li {
        padding: 20px;
        font-size: 28px;
        color: #333;
      }
    }
  }
  .title {
    height: 88px;
    background: #f1f1f1;
    padding: 0 14px;
    font-size: 26px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #449fff;
    p {
      display: inline-block;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #449fff;
        top: 44px;
      }
    }
  }
}
/deep/.van-switch--on {
  background-color: var(--epButtonColor);
}
</style>